import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';

@Injectable({
  providedIn: 'root'
})
export class ToastService {

  constructor(
    private toastr: ToastrService
  ) { }

  successToast(text: string, closeable: boolean = true, duration: number = 3000) {
    this.toastr.success(text, 'Success', {
      timeOut: duration,
      closeButton: closeable,
    });
  }

  warningToast(text: string, closeable: boolean = true, duration: number = 3000) {
    this.toastr.warning(text, 'Warning', {
      timeOut: duration,
      closeButton: closeable,
    });
  }

  errorToast(text: string, closeable: boolean = true, duration: number = 3000) {
    this.toastr.error(text, 'Error', {
      timeOut: duration,
      closeButton: closeable,
    });
  }
}
